const className = '.js-reveal';

const reveal = (className) => {
	// if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
	// if (document.body.classList.contains('reduce')) {
	// 	console.log('Reduced motion request detected, stopping all reveal animations.')
	// 	return;
	// }

	const elements = document.querySelectorAll(className);
  const groups = {};
	const singles = [];
	
	elements.forEach(el => {	// sort elements based on data atribute
		let group = el.dataset.group;
		if (group) {	// if there is no group yet, create
			if (!groups[group]) {
				groups[group] = [];
			}
			groups[group].push(el);
		}
		else {
			singles.push(el);
		}
	});

	function revealNext(element) {
		let group = element.dataset.group;
		if (group) {
			let index = groups[group].indexOf(element);
			if (groups[group][index + 1]) {
				observer.observe(groups[group][index + 1]);
			}
		}
	}

	const observer = new IntersectionObserver((entries) => {
		entries.forEach(entry => {
			let options = {
				easing: entry.target.dataset.easing || "ease-out",
				animation: entry.target.dataset.animation || "reveal-bottom",
				duration: entry.target.dataset.duration || "300",
				delay: entry.target.dataset.delay || "0",
			};

			if (entry.intersectionRatio > 0 && ! entry.target.classList.contains('revealed')) {	// if visible
				// entry.target.style.animation = `${options.easing} forwards ${options.animation} ${options.duration}ms ${options.delay}ms`;
				entry.target.style.animationFillMode = `forwards`;
				entry.target.style.animationDelay = `${options.delay}ms`;
				if (document.body.classList.contains('reduce')) {
					entry.target.style.animationTimingFunction = 'ease-in';
					entry.target.style.animationName = 'reveal-fadein';
					entry.target.style.animationDuration = `${parseInt(options.duration) + 200}ms`;
				}
				else {
					entry.target.style.animationTimingFunction = `${options.easing}`;
					entry.target.style.animationName = `${options.animation}`;
					entry.target.style.animationDuration = `${options.duration}ms`;
				}

				entry.target.addEventListener('animationend', (event) => {
					entry.target.classList.add('revealed');
					revealNext(event.target);	// on animation end add oberver to next in group
				});
			}
			else if (entry.target.getBoundingClientRect().y < 0) {	// if scrolled past
				// entry.target.style.animation = `${options.easing} forwards ${options.animation} ${options.duration}ms 0ms`;
				entry.target.style.animationFillMode = `forwards`;
				entry.target.style.animationDelay = `0ms`;
				entry.target.style.animationDuration = `0ms`;
				if (document.body.classList.contains('reduce')) {
					entry.target.style.animationTimingFunction = 'ease-in';
					entry.target.style.animationName = 'reveal-fadein';
				}
				else {
					entry.target.style.animationTimingFunction = `${options.easing}`;
					entry.target.style.animationName = `${options.animation}`;
				}
				
				entry.target.classList.add('revealed');
				revealNext(entry.target); // asap add oberver to next in group
			}
		});
	}, {
		threshold: [1, 0.5, 0]
	});

	for (let key in groups) {	// observe only fst in group
		observer.observe(groups[key][0]);
	};
	singles.forEach(el => {
		observer.observe(el);
	});
}

reveal('.js-reveal');